import { ProblemSelectableShort } from './problem';
import { Column } from 'react-table';
import { UserDetails } from '../user/user';

export type SolutionUserSummary = {
    id: string;
    problem: ProblemSelectableShort;
    user: UserDetails;
    languageId: number;
    status: number;
    points: number;
    updatedAt: number[];
};

export type SolutionUserDetails = {
    id: string;
    problem: ProblemSelectableShort;
    user: UserDetails;
    languageId: number;
    status: number;
    points: number;
    code: string | null;
    difficulty: number;
    submissions: UserSubmission[];
    createdAt: number[];
};

export type UserSubmission = {
    state: number;
    testId: number;
    testType: number;
    testUUID: string;
    passed: number;
    points: number;
    maxPoints: number;
    statusId: number;
    time: number;
    maxTime: number;
    memory: number;
    maxMemory: number;
};

export type PaginatedSolutionSummary = {
    items: SolutionUserSummary[];
    total: number;
};

export const filteredSolutionsColumns: ReadonlyArray<Column> = [
    {
        Header: '',
        accessor: 'status_badge',
    },
    {
        Header: 'ID',
        accessor: 'id_short',
    },
    {
        Header: 'User',
        accessor: 'user_badge',
    },
    {
        Header: 'Limbaj',
        accessor: 'language_badge',
    },
    {
        Header: 'Puncte',
        accessor: 'points',
    },
    {
        Header: 'Data',
        accessor: 'created_at_date',
    },
];

export const allSolutionsColumns: ReadonlyArray<Column> = [
    {
        Header: '',
        accessor: 'status_badge',
    },
    {
        Header: 'ID',
        accessor: 'id_short',
    },
    {
        Header: 'User',
        accessor: 'user_badge',
    },
    {
        Header: 'Problema',
        accessor: 'problem_badge',
    },
    {
        Header: 'Limbaj',
        accessor: 'language_badge',
    },
    {
        Header: 'Status',
        accessor: 'submission_status_badge',
    },
    {
        Header: 'Puncte',
        accessor: 'points',
    },
    {
        Header: 'Data',
        accessor: 'created_at_date',
    },
];

export const allSubmissionsColumns: ReadonlyArray<Column> = [
    {
        Header: 'Nr',
        accessor: 'test_id',
    },
    {
        Header: 'Tip',
        accessor: 'test_type',
    },
    {
        Header: 'Timp',
        accessor: 'time_badge',
    },
    {
        Header: 'Memorie',
        accessor: 'memory_badge',
    },
    {
        Header: 'Punctaj',
        accessor: 'points_badge',
    },
    {
        Header: 'Status',
        accessor: 'status_badge',
    },
    {
        Header: 'Evaluat',
        accessor: 'passed_badge',
    },
];

export enum SolutionStatus {
    PENDING = 0,
    SENT_TO_EVALUATION = 1,
    EVALUATION_IN_PROGRESS = 2,
    COMPILATION_ERROR = 3,
    EVALUATION_FINISHED = 4,
}
